enum OfficeType {
  AGENT = '10',
  PURCHASE = '20',
  SUPPLIER = '30',
  REGULATOR = '50',
}

export default OfficeType;
